import React from 'react'
import { FilterForm } from '../../../components'
import { SystemProvider } from '../../../features/system/provider'

const Sidebar = ({data, query}) => {
  return (
    <div className="lg:pr-12">
      <SystemProvider>
        <FilterForm
          data={data}
          query={query}
          id="sidebar-filter-form"
          options={{
            keyword: true,
            location: false,
            type: true,
            date: true,
            category: false,
            category_resource: true,
            type_resource: true
          }}
        />
      </SystemProvider>
    </div>
  )
}

export { Sidebar }
